/**
PEARSON PROPRIETARY AND CONFIDENTIAL INFORMATION SUBJECT TO NDA
 *  Copyright © 2026 Pearson Education, Inc.
 *  All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Pearson Education, Inc.  The intellectual and technical concepts contained
 * herein are proprietary to Pearson Education, Inc. and may be covered by U.S. and Foreign Patents,
 * patent applications, and are protected by trade secret or copyright law.
 * Dissemination of this information, reproduction of this material, and copying or distribution of this software
 * is strictly forbidden unless prior written permission is obtained
 * from Pearson Education, Inc.
* */

/**
 * BookCard style
 *
 * @file BookCardStyles.jsx
 * @author Ujjwal Sana
 * @since 1.2.8
 */

import mixins from '../../../assets/styles/mixins.scss';

const SlideArrowStyles = () => ({
  navButton: {
    minWidth: 'unset',
    alignSelf: 'center',
    width: 48,
    height: 48,
    borderRadius: 40,
    zIndex: 2,
    border: `1px solid ${mixins.darkBgBorder}`,
    background: mixins.darkThemeColor,
    '& .MuiButton-label': {
      minWidth: 'unset',
      display: 'inline-flex'
    },
    position: 'absolute',
    top: '40%',
    display: 'inline-flex !important',
    color: mixins.whiteLightFont,
    '&:hover': {
      border: `1px solid ${mixins.whiteLightFont}`,
      background: mixins.darkThemeColor
    },
    '&:focus-visible': {
      background: mixins.darkThemeColor,
      outline: `2px solid ${mixins.secondaryButtonFocusColor})`,
      '&::after': {
        border: 'none'
      }
    }
  },
  navButtonV1: {
    minWidth: 'unset',
    alignSelf: 'center',
    width: 32,
    height: 32,
    borderRadius: 40,
    zIndex: 2,
    border: `1px solid ${mixins.lightTextColor2})`,
    background: mixins.lightBgColor2,
    position: 'absolute',
    top: '40%',
    display: 'inline-flex !important',
    color: mixins.lightTextColor2,
    '& .MuiButton-label': {
      minWidth: 'unset',
      display: 'inline-flex'
    },
    '&:hover': {
      border: `1px solid ${mixins.lightTextColor2})`,
      background: mixins.lightBgColor2
    },
    '&:focus-visible': {
      background: mixins.swatchDarkFont,
      outline: `2px solid ${mixins.secondaryButtonFocusColor})`,
      '&::after': {
        border: 'none'
      }
    },
    '& span': {
      height: 16,
      width: 16,
      '& svg': {
        height: 'inherit',
        width: 'inherit',
        paddingLeft: 2
      }
    }
  },
  contentNav: {
    '&[aria-disabled="true"]': {
      display: 'none !important'
    }
  },
  contentNavV1: {
    '&[aria-disabled="true"]': {
      opacity: 0.32,
      backdropFilter: 'blur(12px)',
      pointerEvents: 'none',
      cursor: 'default',
      '&:focus-visible': {
        outline: 'none'
      }
    }
  },
  seellNav: {
    position: 'relative',
    '&[aria-disabled="true"]': {
      visibility: 'hidden'
    }
  },
  leftNav: {
    transform: 'rotate(180deg)',
    left: '-8px'
  },
  leftNavV1: {
    transform: 'rotate(180deg)',
    display: 'block !important',
    right: '41px',
    top: '-54px',
    left: 'auto'
  },
  rightNav: {
    right: '-8px'
  },
  rightNavV1: {
    display: 'block !important',
    top: '-54px',
    right: '0px'
  }
});

export default SlideArrowStyles;

